import { render, staticRenderFns } from "./MtSaleOrders.vue?vue&type=template&id=448f519a&scoped=true&"
import script from "./MtSaleOrders.vue?vue&type=script&lang=js&"
export * from "./MtSaleOrders.vue?vue&type=script&lang=js&"
import style0 from "./MtSaleOrders.vue?vue&type=style&index=0&id=448f519a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448f519a",
  null
  
)

export default component.exports